import type { NcIconProps } from "./nc-icon";
import { NcIcon } from "./nc-icon";

const NcIconService = (props: NcIconProps) => (
  <NcIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M2.95 3.993A6.55 6.55 0 0 1 12 3.65a6.55 6.55 0 0 1 9.05.343c2.478 2.533 2.594 6.565.348 9.239l-7.95 8.155c-.763.78-1.98.816-2.784.106l-.112-.106-7.95-8.155c-2.246-2.674-2.13-6.706.347-9.24m1.448 1.48c-1.749 1.787-1.798 4.653-.15 6.501l.15.16L12 19.907l5.43-5.552-3.62-3.7-1.086 1.11a3.025 3.025 0 0 1-4.344 0 3.19 3.19 0 0 1 0-4.44l2.151-2.201a4.53 4.53 0 0 0-5.977.197zm8.688 2.96a1.01 1.01 0 0 1 1.448 0l4.344 4.441.724-.74c1.8-1.839 1.8-4.821 0-6.66a4.536 4.536 0 0 0-6.359-.154l-.157.153-3.258 3.33c-.371.38-.398.98-.08 1.39l.08.091c.371.38.957.407 1.359.082l.089-.082z"
    />
  </NcIcon>
);
export { NcIconService };
